var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          { staticClass: "page-header-top-container" },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("Talent Profiles")
            ]),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "col-lg-3 col-sm-12 paddingleft0",
              staticStyle: { "background-color": "transparent" },
              attrs: {
                name: "sele_emp",
                id: "sele_emp",
                clearable: false,
                label: "text",
                options: _vm.usersArr,
                filterable: false,
                placeholder: "Select User"
              },
              on: {
                change: _vm.changedValue,
                input: function($event) {
                  return _vm.changedValueUser()
                },
                search: _vm.onSearchUser
              },
              model: {
                value: _vm.sele_emp,
                callback: function($$v) {
                  _vm.sele_emp = $$v
                },
                expression: "sele_emp"
              }
            }),
            _vm._v(" "),
            _c("v-select", {
              staticClass: "col-lg-1 col-sm-12 paddingleft0",
              staticStyle: { "background-color": "transparent" },
              attrs: {
                name: "sele_year",
                id: "sele_year",
                clearable: false,
                label: "name",
                filterable: true,
                options: _vm.sele_yearArr,
                placeholder: "Select Year"
              },
              on: {
                input: function($event) {
                  return _vm.changedValueYear()
                }
              },
              model: {
                value: _vm.year,
                callback: function($$v) {
                  _vm.year = $$v
                },
                expression: "year"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit", id: "add" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addTalentProfile.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Add")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "teamtalentprofile",
                attrs: {
                  mode: "remote",
                  title: "Team Talent Profile",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c("div", { staticClass: "table-action" }, [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-eye btn edit-btn-vvg waves-effect",
                                      attrs: { "aria-hidden": "true" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.viewProfile(
                                            props.row.emp_id
                                          )
                                        }
                                      }
                                    })
                                  ])
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    })
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9d7935c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9d7935c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/talentprofile/ListTalentProfile.vue
// module id = null
// module chunks = 